import { Component, OnInit } from "@angular/core";
import { HomeService } from "src/app/services/home.service";
import { NocPendingCountModel } from "src/app/model/NocPendingCountModel";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-secure-payment-dashboard",
  templateUrl: "./payment-dashboard.component.html",
  styleUrls: ["./payment-dashboard.component.scss"],
})
export class PaymentDashboardComponent implements OnInit {
  userName: string;
  nocPendingCountModel: NocPendingCountModel;
  loaded: boolean = false;
  date: Date;
  fullCount: number;
  pendingList: any;
  pendingCount: number;
  rejectedNocList: any;
  dataSource: any;
  rejectedDataSource: any;
  paymentDetails: any[] = [];

  pageSize: any = 1;
  pageSizeOptions: any = [10, 20, 30];
  currentPage: any = 0;
  pageChanged(event: any) {
    console.log(event);
  }

  displayedColumns: string[] = [
    "id",
    "applicationNumber",
    "lotteryCOde",
    "schemeCode",
    "nocBank",
    "nocApplyDate",
    "delayDate",
    // "action",
  ];

  rejectedDisplayColumn: string[] = [
    "id",
    "applicationNumber",
    "nocStatus",
    "nocApplyDate",
    "rejectionRemark",
    "rejectedBy",
  ];

  constructor(
    private router: Router,
    private paymentSettlementService: PaymentSettlementService
  ) {}

  showTable: boolean = false;
  showRejectedStatusTable: boolean = false;

  ngOnInit(): void {
    this.paymentDashboardDetails();
  }
  paymentDashboardDetails() {
    this.userName = localStorage.getItem("userName");
    this.loaded = false;
    this.date = null;
    this.fullCount = null;
    this.pendingCount = null;

    this.paymentSettlementService.fetchpaymentDashboardDetails().subscribe(
      (data: any) => {
        console.log(data, "data ");
        // this.fullCount = data[0].fullCount;
        // this.pendingCount = data.pendingCount;
        this.paymentDetails = data;
        // this.dataSource = data.pendingList;
        // this.rejectedNocCount = data.rejectedNocCount;
        // this.rejectedDataSource = data.rejectedNocList;
        for (const payment of this.paymentDetails) {
          console.log(payment.fullCount, "fullCount");
          console.log(payment.pendingCount, "pendingCount");
          console.log(payment.lotteryCode, "lotteryCode");
        }

        console.log(data, "fromList");
        this.loaded = true;
        this.date = new Date();
      },
      (err: any) => {
        console.log(err, " error Method Called");
      }
    );
  }
  // onClickTdsFullCount() {
  //   this.router.navigate([
  //     "/secure",
  //     "payment-settlement",
  //     // ,
  //     // "61",
  //     // "RECONCILIATION_DONE_WITH_TDS",
  //   ]);
  // }

  refresh() {
    this.ngOnInit();
  }
}
